import {
  CalendarOutlined,
  ClockCircleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import caService from "../../../api/caService";
import { getRequest, postRequest } from "../../../api/http";
import "./Task.scss";
import toastr from "toastr";
import { Button, Image, Modal, Popover, Progress, Steps, Tooltip } from "antd";
import { LoadingView } from "../../common";
import lockIcon from "../../../assets/images/lock-xxl.png";
import ApproveIcon from "../../../assets/images/icons/Approve.png";
import LockIcon from '../../../assets/images/icons/lock.png'
import ProgressIcon from "../../../assets/images/icons/Progress.png";
import ErrorIcon from "../../../assets/images/icons/Pagenotfound.svg";
import moment from "moment";
function Task() {
  const location = useLocation();
  const navigate = useNavigate();
  const levelId = location.state.levelId;
  const LevelName = location.state.levelName;
  const LevelStage = location.state.levelStage;
  const [loading, setLoading] = useState(true);
  const [level, setLevel] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const getTasks = async () => {
    setLoading(true);
    try {
      const resonse = await getRequest(caService.getTasks(levelId));
      setTasks(resonse);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toastr.error(error.message);
    }
  };
  const getLevelById = async () => {
    setLoading(true);
    try {
      const resonse = await getRequest(caService.getLevelById(levelId));
      setLevel(resonse);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toastr.error(error.message);
    }
  };
  useEffect(() => {
    getTasks();
    getLevelById();
  }, []);
  const handleNavigate = (id) => {
    navigate("/task-info", {
      state: { taskId: id },
    });
  };
  const handleBeginClick = (task) => {
    setSelectedTask(task);
    setIsModalVisible(true);
  };

  const handleConfirm = async () => {
    try {
      const response = await postRequest(caService.startTask(selectedTask.id));
      getTasks();
      console.log(response, "response");
      setIsModalVisible(false);
      toastr.success("Task started successfully!");
    } catch (error) {
      toastr.error(error.message);
    }
  };
  const levelTypeToLabel = (type) => {
    const mapping = {
      LEVEL_ONE: "Level 1",
      LEVEL_TWO: "Level 2",
      LEVEL_THREE: "Level 3",
      LEVEL_FOUR: "Level 4",
      LEVEL_FIVE: "Level 5",
      LEVEL_SIX: "Level 6",
    };

    return mapping[type] || "Level";
  };
  const customDot = (dot, { status, index }) => {
    const task = tasks[index];
    const statusText =
      task.taskStatus === "COMPLETED"
        ? "completed"
        : task.taskStatus === "IN_PROGRESS"
        ? "in progress"
        : "assigned";
    return (
      <Popover content={<span>{`${task.name} is ${statusText}`}</span>}>
        {dot}
      </Popover>
    );
  };
  const formatDate = (dateTimeString) => {
    const localTime = moment(dateTimeString).local();
    return localTime.format("MMM D , YYYY");
  };
 
  const currentStep = tasks.filter((task) => task.taskStatus === "COMPLETED");
  console.log(currentStep)
  const getStatus = (taskStatus) => {
    if (taskStatus === "COMPLETED") return "finish";
    if (taskStatus === "IN_PROGRESS") return "process";
    return "wait";
  };
  if (loading) return <LoadingView />;
  return (
    <div>
      <div className="header-events">
        <div className="heading">
          {levelTypeToLabel(LevelStage)} - {LevelName}
         
        </div>
        <div className="headingButton">
          <Button onClick={() => navigate(-1)} type="primary">
            Back
          </Button>
        </div>
      </div>
      <div className="level-description-container">
        <div className="level-description">
          <span className="level-description-label">Description:</span>
         {(!level?.levelUnlocked && tasks?.length===0) &&
         <Tooltip title="This level is Locked">
         <Image src={LockIcon} className='locked-icon' preview={false}/>
         </Tooltip>}
        </div>
        <span className="level-description-value">{level?.description}</span>
        <div className="level-description-sub">
          <div className="level-description-date">
            <CalendarOutlined
              className="level-description-icon"
              style={{ color: "#2d83bf" }}
            />
            <span className="level-description-label">Start Date:</span>
            <span className="level-description-value">
              {level?.startDate ? formatDate(level?.startDate) : "-"}
            </span>
          </div>
          <div className="level-description-date">
            <ClockCircleOutlined
              className="level-description-icon"
              style={{ color: "#2d83bf" }}
            />
            <span className="level-description-label">Duration:</span>
            <span className="level-description-value">
              {level?.durationInMonths} months
            </span>
          </div>
        </div>
        <div className="level-description"></div>
      </div>
      {tasks.length > 0 ? (
        <>
          {tasks.length > 1 ? (
          <div className="steps-horizantal">
            <Steps
              current={currentStep.length>0 ?currentStep.length-1:currentStep.length}
              progressDot={customDot}
              items={tasks.map((task) => ({
                title: task.name,
                status: getStatus(task.taskStatus),
              }))}
              style={{marginTop:'10px'}}
            />
          </div>):null}
          <div className="heading" style={{ marginBottom: "10px" }}>
            Tasks
          </div>
          <div className="tasks">
            {tasks?.map((task) => (
              <div key={task.id} className="task-card" onClick={() => handleNavigate(task.id)}>
                <div className="task-header">
                  <div >
                    <div className="task-title">{task?.name}</div>
                    <div className="task-sub">{task?.reportingDetails}</div>
                    <div className="task-date">
                      <FileDoneOutlined twoToneColor="#ed9f0b" /> Submission
                      Limit : {task?.resubmissionCountLimit}
                    </div>
                  </div>
                  <div className="jobs-info">
                    {(task.taskStatus === "ASSIGNED" && level?.levelUnlocked ) && (
                      <div
                        className="Approve-btn"
                        onClick={(e) => {e.stopPropagation(); handleBeginClick(task)}}
                      >
                        Begin
                      </div>
                    )}
                    {task.taskStatus === "IN_PROGRESS" && (
                      <Tooltip title="This task is currently in progress">
                        <div className="user-progress-text">
                          <Image src={ProgressIcon} preview={false} />
                        </div>
                      </Tooltip>
                    )}
                    {task.taskStatus === "COMPLETED" && (
                      <Tooltip title="This task has been completed">
                        <div className="user-progress-text">
                          <Image src={ApproveIcon} preview={false} />
                        </div>
                      </Tooltip>
                    )}
                    {!level?.levelUnlocked && (
                      <Tooltip title="Please complete the previous level to unlock this">
                        <div className="lock-icon">
                          <Image src={lockIcon} preview={false} />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="errorMsg">
          <Image src={ErrorIcon} preview={false} />
          <h3>No Tasks Available!</h3>
        </div>
      )}
      <Modal
        title="Confirm Task Start"
        visible={isModalVisible}
        onOk={handleConfirm}
        onCancel={() => setIsModalVisible(false)}
      >
        <p>Are you sure you want to start the task?</p>
      </Modal>
    </div>
  );
}

export default Task;
